import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "../src/assets/locales/en/translation.json";
import translationHN from "../src/assets/locales/hn/translation.json";
import translationBN from "../src/assets/locales/bn/translation.json";
import translationKN from "../src/assets/locales/kn/translation.json";
import translationTA from "../src/assets/locales/ta/translation.json";

const fallbackLng = ["en"];
const availableLanguages = ["en", "hn", "bn", "kn", "ta"];

const resources = {
  en: {
    translation: translationEN
  },
  hn: {
    translation: translationHN
  },
  bn: {
    translation: translationBN
  },
  kn: {
    translation: translationKN
  },
  ta: {
    translation: translationTA
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,

    detection: {
      checkWhitelist: true
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
